import {ComponentProps} from 'react';
import {InputAdornment} from '@mui/material';
import {LocalizedDecimalField} from './LocalizedDecimalField';
import {useCurrency} from '../../../hooks/useCurrency';
import {getCurrencySymbol} from '../../../common/currency';

export const MoneyField = ({InputProps, ...props}: ComponentProps<typeof LocalizedDecimalField>) => {
    const {currency} = useCurrency();
    return <LocalizedDecimalField {...props} InputProps={{...InputProps, endAdornment: InputProps?.endAdornment ?? <InputAdornment position="end">{getCurrencySymbol(currency)}</InputAdornment>}}/>;
};
